import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import ScrollToTop from "./components/general/ScrollToTop";
import Home from "./pages/Home";
import PageNotFound from "./pages/PageNotFound";
import Art from "./pages/Art";
import ComingSoon from "./pages/ComingSoon";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { retrieveAllArt } from "./firebase";
import { useZustand } from "./zustand/store";
import ArtSection from "./pages/ArtSection";

function App() {
  const { setArtProjects } = useZustand();
  useEffect(() => {
    console.log("Retrieving");
    retrieveAllArt((val: any) => setArtProjects(val));
  }, []);
  return (
    <div className="w-full min-h-screen h-full bg-[#ffffe3]">
      <Router>
        {/* <ScrollToTop /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/art/:slug" element={<Art />} />
          <Route path="/artSection/:slug" element={<ArtSection />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        
      </Router>
    </div>
  );
}

export default App;
